//Menu Button Animation Toggle
document.querySelector('.menu-button').addEventListener('click', function() {
  this.classList.toggle('open');
  document.querySelector('#navigation').classList.toggle('open');
});